export default [
  { name: 'default-theme', label: 'Padrão' },
  { name: 'chiller-theme', label: 'Chiller' },
  { name: 'legacy-theme', label: 'Legacy' },
  { name: 'ice-theme', label: 'Fire' },
  { name: 'cool-theme', label: 'Cool' },
  { name: 'light-theme', label: 'Light Black' },
  { name: 'light-red', label: 'Light Red' },
  { name: 'light-green', label: 'Light Green' },
  { name: 'light-purple', label: 'Light Purple' },
  { name: 'light-blue', label: 'Light Blue' },
  { name: 'september-theme', label: 'Setembro Amarelo' },
  { name: 'october-theme', label: 'Outubro Rosa' },
  { name: 'november-theme', label: 'Novembro Azul' },
  { name: 'christmas-theme', label: 'Natal' },
  { name: 'newy-theme', label: 'Ano Novo' },
  { name: 'new-theme', label: 'Midninght' },
  { name: 'new-red', label: 'Full Red' },
  { name: 'new-green', label: 'Full Green' },
  { name: 'new-purple', label: 'Full Purple' },
  { name: 'new-blue', label: 'Full Blue' }
];
